<template>
  <div class="pt-5">
    <CommonExpansionPanel :currentPanel="currentPanel" :readonly="readonly">
      <template v-slot:title-panel>
        Seguimiento de la Solicitud
      </template>
      <v-expansion-panel-content>
        <v-form ref="firstStepForm" :lazy-validation="true">
          <v-row>
            <v-col cols="12" md="12">
              <v-autocomplete
                v-model="solicitudData.empresaId"
                :items="empresas"
                label="Empresa de atención"
                item-value="id"
                item-text="empresa"
                outlined
                primary
                color="#00a7e4"
                :rules="requiredRule"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.empresa }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ usuario.empresaId.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              style="text-align: end;"
            >
              <v-btn
                rounded
                dark
                outlined
                color="#00a7e4"
                @click="$emit('ChangeOnlyStep', 2, null)"
                style="margin-right: 11px;"
              >
                <span>
                  Anterior
                </span>
              </v-btn>
              <v-btn rounded dark class="common-botton" @click="validateStep">
                <span style="padding-right: 11%;">
                  Guardar
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import { mainAxios } from "@/mainAxios.js";
import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";

export default {
  components: {
    CommonExpansionPanel,
  },

  props: {
    currentStep: Number,
  },

  data() {
    return {
      solicitudData: {
        operadorUuid: null,
        procesoCotizacionSelected: "Cotización",
        solicitudCompletaSelected: "Si",
        checkPendienteInfo: false,
        checkCancelacion: false,
        causaPendienteInformacion: null,
      },
      requiredRule: [(v) => !!v || "El campo es requerido"],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      currentPanel: null,
      readonly: true,
      ejecutivos: [],
      procesoCotizacion: ["Cotización", "Emisión", "Finalizado"],
      solicitudCompleta: ["Si", "No"],
      empresas: [],
    };
  },
  watch: {
    currentStep(val) {
      if (val == 3) {
        this.currentPanel = 0;
        this.readonly = false;
      } else {
        this.currentPanel = 1;
        this.readonly = true;
      }
    },
  },
  computed: {
    isAgente() {
      return this.rol == "AGENT";
    },

    isAgenteDirecto() {
      const agente = this.agentes.find(
        (a) => a.id == this.solicitudData.agente
      );
      if (!agente) return false;

      return !!agente.canalList.find((canal) => canal.id == 3);
    },

    esInbound() {
      return this.rol.includes("INBOUND");
    },
  },
  methods: {
    validateStep() {
      if (this.$refs.firstStepForm.validate()) {
        this.$emit("goToSave", this.solicitudData);
      }
    },

    beforeStep() {
      this.$emit("ChangeOnlyStep", 2, null);
    },

    obtenerEjecutivos() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/agentes/operador", config).then((response) => {
        response.data.map((element) => {
          this.ejecutivos.push({
            nombre:
              `${element.nombre}` +
              " " +
              `${element.apellidoPaterno}` +
              " " +
              `${element.apellidoMaterno ? element.apellidoMaterno : ""}`,
            id: element.id,
            uuid: element.uuid,
          });
          if (this.rol == "OPERADOR") {
            localStorage.agenteUuid == element.uuid
              ? (this.form.ejecutivo = element.uuid)
              : "";
          }
        });
      });
    },
    async getEmpresasInbound() {
      let response = await getEmpresasInbound();
      console.log({ response });
      this.empresas = response.data.empresas ?? [];
    },
  },

  mounted() {
    this.obtenerEjecutivos();
    this.getEmpresasInbound();
  },
};
</script>
